import { render, staticRenderFns } from "./ExternalDefinition.vue?vue&type=template&id=ad859be8&scoped=true&"
import script from "./ExternalDefinition.vue?vue&type=script&lang=js&"
export * from "./ExternalDefinition.vue?vue&type=script&lang=js&"
import style0 from "./ExternalDefinition.vue?vue&type=style&index=0&id=ad859be8&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad859be8",
  null
  
)

export default component.exports